

<template>
  <div class="container" v-loading="loading">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <a class="banner-link" href="" target="">
            <img
                :src="item.src"
                :alt="item.title"
                class="carousel-img"
            />
          </a>
        </el-carousel-item>
      </el-carousel>

      <!-- 面包屑 -->
      <div class="crumbs">
        <p>
          <a href="/table" target="">首页</a> /
          <a href="" target="">签约球员</a>
        </p>
      </div>
    </div>

    <div class="container-list">
    <div class="player-list">
      <div v-for="(item, index) in playerList"
           :key="index">
        <div class="product-item" @click="handlePlayerClick(item.id)">
          <img :src="item.fileEchoVo.url" alt="">
          <div class="product-desc">
            <h3 class="nowrap">{{item.name}}</h3>
            {{formatDesc(item.intro)}}
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import {getImgList, selectPlayerList} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  name: 'PlayerList',
  data() {
    return {
      loading: false,
      topImgList: [],
      playerList:[],
    }
  },
  created() {
    this.getBannerList();

    this.selectPlayerList();
  },
  methods:{
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;
        const res = await getImgList(ImageTypeEnum.PLAYER_HOME_BANNER.value);
        const dataList = res.data || [];
        this.topImgList = dataList.filter(item => item.classify === ImageTypeEnum.PLAYER_HOME_BANNER.value && item.src);
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //获取球员列表数据
    async selectPlayerList() {
      try {
        this.loading = true;
        const res = await selectPlayerList();
        if (res.code === 200) {
          console.log(104,res);
          this.playerList = res.data.rows;
        } else {
          this.$message.error(res.msg || "获取球员列表失败");
        }
      } catch (error) {
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    formatDesc(text) {
      if (!text) return "";
      // 响应式判断：小屏截取40字，大屏截取50字
      const maxLength = window.innerWidth <= 768 ? 40 : 50;
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    // 点击球员跳转详情
    handlePlayerClick(id) {
      // 跳转球员详情页
      this.$router.push({
        path: "/playerDetail",
        query: {
          playerId: id,
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  position: relative;
  width: 100%;
  //max-width: 1920px; // 限制最大宽度，适配大屏
  margin: 0 auto;
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-top: 80px;
  }
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 280px !important;

  @media (max-width: 768px) {
    height: 200px !important;
  }
  @media (max-width: 480px) {
    height: 150px !important;
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图链接
.banner-link {
  display: block;
  width: 100%;
  height: 100%;
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

// 面包屑容器
.crumbs {
  position: absolute;
  bottom: 38px;
  left: 9%;
  width: 82%;
  padding: 20px 30px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 10;

  @media (max-width: 768px) {
    bottom: 20px;
    left: 5%;
    width: 90%;
    padding: 15px 20px;
  }
  @media (max-width: 480px) {
    bottom: 10px;
    padding: 10px 15px;
  }
}

// 面包屑文本
.crumbs p {
  color: #999;
  font-size: 12px;
  line-height: 20px;

  @media (max-width: 480px) {
    font-size: 11px;
  }
}

// 面包屑链接
.crumbs p a {
  display: inline-block;
  vertical-align: top;
  margin: 0 10px;
  color: #999;
  text-decoration: none;
  transition: color 0.2s ease;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: #000;
  }

  @media (max-width: 480px) {
    margin: 0 5px;
  }
}

// 面包屑h2样式
.crumbs h2 {
  font-size: 30px;
  color: #555;
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
  @media (max-width: 480px) {
    font-size: 18px;
  }
}

.container-list {
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
}

.player-list {
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 5%;
}

// 外层循环项样式不变
.player-list > div {
  position: relative;
  float: left;
  width: 24%;
  margin-right: 1%;
  margin-bottom: 20px;
  padding-top: 36%;
}

// 替换后的product-item（原a标签）样式
.player-list > div .product-item {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer; // 保留点击指针样式，模拟a标签交互

  img {
    max-height: 100%;
    max-width: 100%;
    display: block;
    border: none;
  }
}

// 产品描述层（原内部div）样式调整类名
.player-list > div .product-desc {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 20px 15px;
  background: #a8a8a8;
  // 修复层级选择器，避免样式冲突
  box-sizing: border-box;

  &::before {
    z-index: 33;
    position: absolute;
    content: '';
    left: 15%;
    top: -32px;
    border: 16px solid transparent;
    border-bottom-color: #a8a8a8;
  }
}

// 标题样式
.player-list .product-desc h3 {
  padding-bottom: 10px;
  font-size: 18px;
  border-bottom: 1px dotted #333;
  margin: 0; // 清除默认margin，保证布局精准
}

// 描述文本样式（补充p标签/文本容器样式）
.player-list .product-desc {
  color: #333; // 补充文本颜色
  font-size: 14px; // 统一文本字号
  line-height: 24px;

  // 描述内容高度限制
  & > :nth-child(2) {
    height: 48px;
    margin-top: 10px;
    line-height: 24px;
    overflow: hidden;
  }
}
</style>